module.exports = __webpack_public_path__ + "static/knorr-logo-no-bg-f2fc021a73c39a7eccbec3dad3e236e7.svg";